import React, { useState, useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';
import PropTypes from "prop-types";
import Modal from 'react-modal';
import OverlayCard from '../AmountOverlay/OverlayCard';
import './style.scss';
import ActionsOverlay from '../ActionsOverlay/ActionsOverlay';
import axios from 'axios';
import PtpOverlay from '../PtpOverlay/PtpOverlay';
import { useSelector } from 'react-redux';

const PieCard = ({ data, title, number, description }) => {

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [actionsDrillDown, setActionsDrillDown] = useState([]);
    const [ptpDrillDown, setPtpDrillDown] = useState([])
    const chartRef = useRef(null);
    const selectedFilterValues = useSelector(state => state.filterValues.filterValues);
    const [apiCallMade, setApiCallMade] = useState(false);

    const aggregatedCounts = {};

    if (Array.isArray(actionsDrillDown)) {
        actionsDrillDown?.forEach(action => {
            const { count, actionCode } = action;
            if (aggregatedCounts[actionCode]) {

                aggregatedCounts[actionCode].count += count;
            } else {

                aggregatedCounts[actionCode] = { count };
            }
        });
    }

    const convertedActions = Object.entries(aggregatedCounts).map(([actionCode, { count }], index) => ({
        id: index + 1,
        name: actionCode,
        value: count
    }));

    const aggregatedstatusCounts = {};

    if (Array.isArray(actionsDrillDown)) {
        actionsDrillDown?.forEach(action => {
            if (!aggregatedstatusCounts[action.contactStatus]) {
                aggregatedstatusCounts[action.contactStatus] = 0;
            }
            aggregatedstatusCounts[action.contactStatus] += action.count;
        })
    }

    const formattedData = Object.entries(aggregatedstatusCounts).map(([name, value]) => ({ name, value }));
    console.log("formatted data =======>", formattedData);

    const baseUrl = process.env.REACT_APP_BASE_URL;
    const apiActionDrilldownURL = `${baseUrl}/api/dashboard/collections/charts/actions/drill-down`;
    const apiPtpDrilldownUrl = `${baseUrl}/api/dashboard/collections/charts/promises/drill-down`

    const openModal = () => {
        setModalIsOpen(true);
    }

    useEffect(() => {
        if (title === 'Actions' && !apiCallMade && modalIsOpen) {
            const fetchDrilldownActionsData = async () => {
                try {
                    let payload = {
                        filter: []
                    };

                    if (selectedFilterValues.HUB !== "" && selectedFilterValues.HUB !== undefined) {
                        payload.filter.push({
                            id: "ACCOUNTS.HUB",
                            value: selectedFilterValues.HUB,
                        });
                    }

                    if (selectedFilterValues.AREA !== "" && selectedFilterValues.AREA !== undefined) {
                        payload.filter.push({
                            id: "ACCOUNTS.AREA",
                            value: selectedFilterValues.AREA,
                        });
                    }

                    if (selectedFilterValues.from !== "" && selectedFilterValues.from !== undefined) {
                        payload.filter.push({
                            id: "ACTION_HISTORY.ACTION_TAKEN_ON",
                            datatype: "DATE",
                            value: {
                                "from": `${selectedFilterValues.from}`
                            }
                        });
                    }

                    const response = await axios.post(apiActionDrilldownURL, payload);
                    setActionsDrillDown(response?.data?.data);
                    setApiCallMade(true);
                } catch (error) {
                    console.error(error);
                }
            };

            fetchDrilldownActionsData();

        }
        else if (title === 'Arrangements/PTP' && modalIsOpen) {
        
            const fetchDrilldownPtpData = async () => {
                try {
                    let payload = {
                        filter: []
                    }

                    if (selectedFilterValues.HUB !== "" && selectedFilterValues.HUB !== undefined) {
                        payload.filter.push({
                            id: "ACCOUNTS.HUB",
                            value: `${selectedFilterValues.HUB}`,
                        });
                    }

                    if (selectedFilterValues.AREA !== "" && selectedFilterValues.AREA !== undefined) {
                        payload.filter.push({
                            id: "ACCOUNTS.AREA",
                            value: `${selectedFilterValues.AREA}`,
                        });
                    }

                    if (selectedFilterValues.BRANCH !== "" && selectedFilterValues.BRANCH !== undefined) {
                        payload.filter.push({
                            id: "ACCOUNTS.ASSOCIATED_BRANCH",
                            value: `${selectedFilterValues.BRANCH}`,
                        });
                    }
                    if (selectedFilterValues.from !== "" && selectedFilterValues.from !== undefined &&
                        selectedFilterValues.to !== "" && selectedFilterValues.to !== undefined) {
                        payload.filter.push({
                            "id": "ACTION_HISTORY.ACTION_TAKEN_ON",
                            "datatype": "DATE",
                            "value": {
                                "from": `${selectedFilterValues.from}`,
                                "to": `${selectedFilterValues.to}`
                            },
                        })
                    }
                    const response = await axios.post(apiPtpDrilldownUrl, payload);
                    setPtpDrillDown(response.data.data);
                } catch (error) {
                    console.error(error);
                }
            };
            fetchDrilldownPtpData();
        }
    }, [selectedFilterValues, modalIsOpen, title])

    const closeModal = () => {
        setModalIsOpen(false);
        setActionsDrillDown([]); // wipe data 
        setPtpDrillDown([]);
        setApiCallMade(false);
    };

    PieCard.propTypes = {
        title: PropTypes.string.isRequired,
        number: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        data: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            value: PropTypes.number.isRequired,
        })).isRequired,
    };

    useEffect(() => {
        if (chartRef && chartRef.current) {
            const ctx = chartRef.current.getContext('2d');

            const labels = data.map(item => item.name);
            const values = data.map(item => item.value);

            const myChart = new Chart(ctx, {
                type: 'pie',
                data: {
                    labels: labels,
                    datasets: [{
                        data: values,
                        backgroundColor: [
                            'rgba(133, 113, 244, 1)',
                            'rgba(9, 114, 121, 1)',
                            'rgba(48, 206, 216, 1)',
                            'rgba(76, 214, 180, 1)',
                            'rgba(131, 60, 202, 1)',
                            'rgba(30, 156, 164, 1)'
                        ],
                        borderColor: [
                            'rgba(133, 113, 244, 1)',
                            'rgba(9, 114, 121, 1)',
                            'rgba(48, 206, 216, 1)',
                            'rgba(76, 214, 180, 1)',
                            'rgba(131, 60, 202, 1)',
                            'rgba(30, 156, 164, 1)'
                        ],
                        borderWidth: 1
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        tooltip: {
                            callbacks: {
                                label: function (context) {
                                    return context.label + ': ' + context.formattedValue;
                                }
                            }
                        },
                        legend: {
                            display: false
                        }
                    }
                }
            });

            return () => {
                myChart.destroy();
            };
        }
    }, [data]);

    const isPositiveDescription = description && /^\d/.test(description);

    return (
        <>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Pie Chart Modal"
                className="modal"
                style={{
                    overlay: {
                        backgroundColor: 'rgba(45, 45, 45, 0.8)', // Background color of the overlay
                    },
                }}
            >
                {title === 'Actions' && <ActionsOverlay data={data} statusData={formattedData} drillDown={convertedActions} title={title} number={number} description={description} />}
                {title === 'Arrangements/PTP' && <PtpOverlay data={ptpDrillDown} title={title} number={number} description={description} />}
                {title === 'Collected Amount' && <OverlayCard data={data} title={title} number={number} description={description} />}
            </Modal>
            <div className="pie-card">
                {/* <div className="card-header">
                    <h3>{title}</h3>
                </div> */}
                <div className="pie-card__body">
                    <div className='pie-card__body__content'>
                        <h3>{title}</h3>
                        <h2>{number}</h2>
                    </div>
                    <div className='pie-card__body__chart'>
                        <canvas ref={chartRef}></canvas>
                    </div>
                </div>
                <div className="pie-card__footer">
                    <p className={isPositiveDescription ? 'positive-description' : 'negative-description'}>{description}</p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="27" viewBox="0 0 26 27" fill="none" onClick={openModal}>
                        <path d="M21.7092 12.5384L15.8723 5.78401C15.4704 5.31889 14.8198 5.31889 14.437 5.78401C14.0351 6.24914 14.0351 7.00207 14.437 7.44487L18.5516 12.2062L4.84925 12.2062C4.29431 12.2062 3.83492 12.7378 3.83492 13.3799C3.83492 14.0221 4.29431 14.5537 4.84925 14.5537L18.5324 14.5537L14.437 19.3149C14.0351 19.7801 14.0351 20.533 14.437 20.9759C14.6285 21.1974 14.8964 21.3302 15.1643 21.3302C15.4322 21.3302 15.681 21.2195 15.8915 20.9759L21.7476 14.1993C21.939 13.9778 22.0538 13.6678 22.0538 13.3578C22.0155 13.07 21.9007 12.76 21.7092 12.5384Z" fill="#D9D9D9" />
                    </svg>
                </div>
            </div>
        </>
    );
};

export default PieCard;
